import { render, staticRenderFns } from "./tablaTallas.vue?vue&type=template&id=6a9cfb6e&scoped=true&"
import script from "./tablaTallas.vue?vue&type=script&lang=js&"
export * from "./tablaTallas.vue?vue&type=script&lang=js&"
import style0 from "./tablaTallas.vue?vue&type=style&index=0&id=6a9cfb6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a9cfb6e",
  null
  
)

export default component.exports